import { observable, action } from 'mobx';

class GlobalStore {
  @observable productionDetail = {};

  @observable customerDetail = {};// 客户资料信息

  @observable orderInfo = {};

  @observable singleAnswers = [];

  @observable scoreArr = [];

  @action setProductionDetail = (value) => {
    this.productionDetail = value;
  };

  @action setOrderInfo = (value) => {
    this.orderInfo = value;
  };

  @action setCustomerDetail = (value) => {
    this.customerDetail = value;
  };

  @action setSingleAnswers = (value, answer) => {
    let index = 0;
    if (this.singleAnswers.some((item) => item.questionsId === answer.questionsId)) {
      index = this.singleAnswers.findIndex((item) => item.questionsId === answer.questionsId);
      this.singleAnswers.splice(index, 1, value);
    } else {
      this.singleAnswers.push(value);
    }
  };
}

export default new GlobalStore();
